"use strict";exports.waitForAnimations=async function(t,i){const n=t.getAnimations(i).map((({finished:t})=>t));await Promise.allSettled(n)};
